import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCategories } from "../../redux/shop/selectors";
import { useWindowWidth } from "../../hooks/useWindowWidth";
import { Container } from "../Container/Container";
import { ReactComponent as ArrowRight } from "../../icons/ArrowRight.svg";

import {
  AllCategoryLinkStyled,
  FooterAddressStyled,
  FooterLinksStyled,
  FooterLogoLinkStyled,
  FooterStyled,
} from "./Footer.styled";
import React from "react";

export const Footer = () => {
  const width = useWindowWidth();
  const categories = useSelector(selectCategories);

  return (
      <FooterStyled>
        <Container>
          <div>
            <FooterLogoLinkStyled to="/">
              <img src="/logo_new.jpeg" className="rounded-full" style={{ borderRadius: '100%' }}
                    alt="Kupidai logo" loading="lazy" width="32"
                   height="32"/>
              <span>Kupidai</span>
            </FooterLogoLinkStyled>
            <FooterAddressStyled>
              <p>Контакты поддержки:</p>
              <a href="tel:+77014034048">+7 (701) 403-40-48</a>
              <a href="tel:+77759474150">+7 (775) 947-41-50</a>
            </FooterAddressStyled>

            <FooterAddressStyled>
              <p>ИП Назаркулов Х.</p>
              <p>Республика Казахстан, Туркестанская область,</p>
              <p>Сайрамский р-н, с. Манкент, ул. Улугбек 5/5</p>
              <p>ИИН: 820507302043</p>
              <a href="mailto:hayat_1982@mail.ru">
                hayat_1982@mail.ru
              </a>
            </FooterAddressStyled>
          </div>

          {width > 1023 && (
              <FooterLinksStyled>
              <h2>Все категории</h2>
                <ul>
                  {categories.slice(0, 6).map(({ slug, name }) => (
                      <li key={slug}>
                        <NavLink to={`/shop/${slug}`}>
                          {name}
                        </NavLink>
                      </li>
                  ))}
                </ul>
                <AllCategoryLinkStyled to="/shop">
                  Показать все продукты
                  <ArrowRight />
                </AllCategoryLinkStyled>
              </FooterLinksStyled>
          )}

          {width > 1199 && (
              <FooterLinksStyled>
                <h2>Быстрые ссылки</h2>
                <ul>
                  <li>
                    <NavLink to="/cart">Корзина</NavLink>
                  </li>
                  <li>
                    <NavLink to="/wishlist">Список избранное</NavLink>
                  </li>
                  <li>
                    <NavLink to="/contacts">Контакты</NavLink>
                  </li>
                  <li>
                    <a
                        href="/docs/privacy_policy.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                      Политика конфиденциальности
                    </a>
                  </li>
                  <li>
                    <a
                        href="/docs/terms_of_service.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                      Пользовательское соглашение
                    </a>
                  </li>
                </ul>
              </FooterLinksStyled>
          )}
        </Container>
      </FooterStyled>

  );
};
